import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs/index";
import {connectApi} from "../connect-api";
import {CustomHttpParams} from "../connect-http-interceptor";
import {map} from "rxjs/internal/operators";
import {Account} from "../model/account";
import {Utils} from "../utils";
import {Contact} from "../contact";
import {AutoSuggest} from "./dp-auto-suggest";

@Injectable({
    providedIn: 'root'
})
export class DpAutoSuggestService {


    constructor(private httpClient: HttpClient) {
    }


    getAutoSuggestList(value: string, type: string, lawFirmId?: number): Observable<AutoSuggest[]> {
        if (type == 'ACCOUNT_LIST') {
            return this.getAccountList(value);
        }
        if (type == 'LAW_FIRM' || type == 'REALESTATEBROKER' || type == 'SOLICITOR') {
            return this.getContactList(value, type, undefined, 'ACTIVE', 1, 15, lawFirmId);
        }
        else {
            return of([], undefined);
        }
    }


    getContactList(value: string, type: string, sortQuery: string, contactStatusSearch: string
        , page: number, perPage: number, lawFirmId?: number): Observable<AutoSuggest[]> {
        let urlQuery = value ? value.trim() : '';
        let sortingType = 'ASC';
        let url: string;
        let filter: string = '';
        let sort: string = '';
        let sortType: string = '';
        urlQuery = Utils.escapeSearchText(urlQuery);
        let addressHashPart: string = Utils.removeSpecialCharactersFromAddressSearch(urlQuery);
        let replacedAddressHashPart: string = addressHashPart && addressHashPart.length > 0 ? Utils.escapeSearchText(addressHashPart) : "";


        switch (type) {
            case 'LAW_FIRM':
                sortType = sortingType ? sortingType : 'ASC';
                sort = sortQuery ? sortQuery : 'legalFirmName';
                filter = urlQuery && urlQuery.length > 0 ? 'ANYlegalFirmName_EQ_*' + urlQuery + '*' : '';
                if (replacedAddressHashPart) {
                    filter += '|contactMailingAddress.listSearchAddressHash_EQ_mailing:*' + replacedAddressHashPart + '*'
                }
                filter = Utils.appendContactStatusFilter(filter, contactStatusSearch);
                sort = Utils.parseSort(sort, sortType);
                url = filter && filter.length > 0 ?
                    `${connectApi.contactsList}?contactType=${type}&sort=${sort}&filter=${filter}`
                    : `${connectApi.contactsList}?contactType=${type}&sort=${sort}`;
                break;
            case 'REALESTATEBROKER':
                sortType = sortingType ? sortingType : 'ASC';
                sort = sortQuery ? sortQuery : 'organizationName,contactMailingAddress.addressHash';
                filter = urlQuery && urlQuery.length > 0 ? 'ANYorganizationName_EQ_*' + urlQuery + '*' : '';
                if (replacedAddressHashPart) {
                    filter += '|contactMailingAddress.listSearchAddressHash_EQ_mailing:*' + replacedAddressHashPart + '*'
                }
                filter = Utils.appendContactStatusFilter(filter, contactStatusSearch);
                sort = Utils.parseSort(sort, sortType);
                url = filter && filter.length > 0 ?
                    `${connectApi.contactsList}?contactType=${type}&sort=${sort}&filter=${filter}`
                    : `${connectApi.contactsList}?contactType=${type}&sort=${sort}`;
                break;
            case 'SOLICITOR':
                if(lawFirmId){
                    url = `${connectApi.contacts}/${lawFirmId}/solicitors?sort=contactName.lastName|ASC&filter=contactType_EQ_SOLICITOR|activeFlag_IN_${Utils.escapeSearchText('Y_n')}!YES`;
                } else {
                    url = `${connectApi.searchSolicitors}?contactType=SOLICITOR&filter=${urlQuery}`;
                }
                break;

        }
        if (page) {
            url = url + `&page=${page}&per_page=${perPage}`;
        }
        return this.httpClient
            .get<any[]>(Utils.encodePipe(Utils.normalizeUrl(url)), {
                params: new CustomHttpParams(true)
            })
            .pipe(map(res => {
                let list: AutoSuggest[] = [];
                if (res['Contacts']) {
                    let contactsList: Contact[] = res['Contacts'].map(contact => {
                        return new Contact(contact)
                    });
                    if (typeof value == 'string' && (!contactsList || (contactsList && contactsList.length == 0))) {

                        list.push(new AutoSuggest('NO_RECORD_FOUND', 'No Records Found'))
                    }
                    else if (type == 'LAW_FIRM') {
                        list.push(...contactsList.map(item => {
                            return new AutoSuggest(item.id, item.legalFirmName, (item.mailingAddress ? item.mailingAddress.fullAddress : null), (!!item.displayName && item.legalFirmName != item.displayName ? item.displayName : null));
                        }));
                    }
                    else if (type == 'REALESTATEBROKER') {
                        list.push(...contactsList.map(item => {
                            return new AutoSuggest(item.id, (item.displayName ? item.displayName : item.organizationName), item.mailingAddress ? item.mailingAddress.fullAddress : null);
                        }));
                    }
                    else if (type == 'SOLICITOR') {
                        list.push(...contactsList.map(item => {
                            return new AutoSuggest(item.id, item.displayName, item.firmName, (item.mailingAddress ? item.mailingAddress.fullAddress : null), item);
                        }));
                    }
                }
                if(res['Solicitors']){
                    let contactsList: Contact[] = res['Solicitors'].map(contact => {
                        return new Contact(contact)
                    });
                    list.push(...contactsList.map(item => {
                        return new AutoSuggest(item.id, item.displayName, item.firmName, (item.mailingAddress ? item.mailingAddress.fullAddress : null), item);
                    }));
                }
                return list;
            }));

    }

    getAccountList(query: string): Observable<AutoSuggest[]> {
        let url: string;
        let urlQuery = query;
        urlQuery = Utils.escapeSearchText(urlQuery);
        let filter: string = '';
        let filterFlag: boolean = true;
        filter += "customerAccountStatus_EQ_ACTIVE";
        if (urlQuery && urlQuery != '') {
            filter = Utils.addCommaToFilter(filter);
            filter += 'ANYpublicAccountId_EQ_*' + urlQuery + '*|firmName_EQ_*' + urlQuery + '*';
        }
        url = filterFlag ?
            `${connectApi.getAccounts}?sort=createdTimeStamp|DESC&filter=${filter}&filterType=ALL`
            : `${connectApi.getAccounts}?sort=createdTimeStamp|DESC`;

        return this.httpClient
            .get<Account[]>(Utils.encodePipe(Utils.normalizeUrl(url)), {
                params: new CustomHttpParams(true)
            })
            .pipe(map(res => {
                let list: AutoSuggest[] = [];
                let customerAccountsList: Account[] = res['CustomerAccounts'].map(account => {
                    return new Account(account);
                })
                if (typeof query == 'string' && (!customerAccountsList || (customerAccountsList && customerAccountsList.length == 0))) {

                    list.push(new AutoSuggest('NO_RECORD_FOUND', 'No Records Found'))
                }
                else {
                    list.push(...customerAccountsList.map(item => {
                        return new AutoSuggest(item.id, item.firmName, (item.mailingAddress ? item.mailingAddress.fullAddress : null), undefined, item);
                    }));
                }
                return list;
            }));
    }
}
